
export { localStorageUtils } from "/codebuild/output/src1614243332/src/packages/utils/src/storage/index.ts"